// extracted by mini-css-extract-plugin
export var headerXL = "SectionEbooks-module--headerXL--1yot7";
export var headerL = "SectionEbooks-module--headerL--1EABA";
export var headerM = "SectionEbooks-module--headerM--1v5Aj";
export var headerS = "SectionEbooks-module--headerS--2i5v_";
export var headerXS = "SectionEbooks-module--headerXS--3iVxB";
export var blogHeaderXL = "SectionEbooks-module--blogHeaderXL--2NB0g";
export var blogHeaderL = "SectionEbooks-module--blogHeaderL--23aGi";
export var blogHeaderM = "SectionEbooks-module--blogHeaderM--HTQoq";
export var blogHeaderS = "SectionEbooks-module--blogHeaderS--3QWIq";
export var blogHeaderXS = "SectionEbooks-module--blogHeaderXS--2n2Hp";
export var headerPreamble = "SectionEbooks-module--headerPreamble--dTaRt";
export var preHeader = "SectionEbooks-module--preHeader--HUa1s";
export var textNormal = "SectionEbooks-module--textNormal--2yfWv";
export var textSmall = "SectionEbooks-module--textSmall--2zDWM";
export var textSmallAlternate = "SectionEbooks-module--textSmallAlternate--2u9na";
export var legend = "SectionEbooks-module--legend--1XJ4c";
export var caption = "SectionEbooks-module--caption--1gb3j";
export var gradientBackground = "SectionEbooks-module--gradientBackground--3PdYI";
export var ellipsis = "SectionEbooks-module--ellipsis--p5TFD";
export var globalContainer = "SectionEbooks-module--globalContainer--1RNQA";
export var maxWidth = "SectionEbooks-module--maxWidth--3I0Ca";
export var clipBottom = "SectionEbooks-module--clipBottom--PxLlz";
export var clipTopBottom = "SectionEbooks-module--clipTopBottom--1jbhZ";
export var contentBody = "SectionEbooks-module--contentBody--2gk6l";
export var sectionEbooks = "SectionEbooks-module--sectionEbooks--2H2tS";
export var container = "SectionEbooks-module--container--3ADoQ";
export var content = "SectionEbooks-module--content--1jUlZ";
export var contentHTML = "SectionEbooks-module--contentHTML--1mXFD";
export var ebook = "SectionEbooks-module--ebook--3F1kw";
export var image = "SectionEbooks-module--image--3wAGf";
export var ebookInfo = "SectionEbooks-module--ebookInfo--1Usg_";
export var downloadButton = "SectionEbooks-module--downloadButton--3zERU";
export var ch2 = "SectionEbooks-module--ch2--3mMLo";
export var ch2Container = "SectionEbooks-module--ch2-container--tkf9-";